import angular from 'angular'

import commonTemplate from 'views/common/template.html'

import { workspace, invoice, ovatBill, openedInvoice, redWordInfo, cancelInvoice, management, vehicleInvoice, reimbursement } from 'redevConfig'
const invoiceAdd = (invoice && invoice.add) || ''
const openedInvoiceDetail = (openedInvoice && openedInvoice.detail) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''
const redWordInfoDetail = (redWordInfo && redWordInfo.detail) || ''
const cancelInvoiceDetail = (cancelInvoice && cancelInvoice.detail) || ''
const managementDetail = (management && management.detail) || ''
const vehiceDetail = (vehicleInvoice && vehicleInvoice.add) || ''
const rollDetail = (openedInvoice && openedInvoice.rollDetail) || ''
const reimbursementDetail = (reimbursement && reimbursement.detail) || ''
const invoiceDetail = (invoice && invoice.detail) || ''
const list = (workspace && workspace.list) || ''
const detail = (workspace && workspace.detail) || ''

const billDetailPage = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('app/outputManage/fillOpenManage/ovatBill/view/checkBillDetailCtrl.html')
const detailInvoicePage = invoiceDetail ? require(`redevelopment/outputManage/invoice/${invoiceDetail.templateName}`) : require('app/outputManage/fillOpenManage/invoice1/view/invoiceDetail.html')
const openedInvoiceDetailPage = openedInvoiceDetail ? require(`redevelopment/outputManage/openedInvoice/${openedInvoiceDetail.templateName}`) : require('app/outputManage/billManage/openedInvoice/view/openedInvoiceDetail.html')
const redInfoDetailPage = redWordInfoDetail ? require(`redevelopment/outputManage/redWordInfo/${redWordInfoDetail.templateName}`) : require('app/outputManage/fillOpenManage/redWordInfo/view/redInfoDetail.html')
const cancelInvoiceDetailPage = cancelInvoiceDetail ? require(`redevelopment/outputManage/cancelInvoice/${cancelInvoiceDetail.templateName}`) : require('app/outputManage/billManage/cancelInvoice/view/cancelInvoiceDetail.html')
const managementDetailPage = managementDetail ? require(`redevelopment/input/management/${managementDetail.templateName}`) : require('app/input/inputInvoice/management/view/managementDetail.html')
const vehicleDetailPage = vehiceDetail ? require(`redevelopment/outputManage/vehicleInvoice/${vehiceDetail.templateName}`) : require('app/outputManage/fillOpenManage/vehicleInvoice/view/add.html')
const rollDetailPage = rollDetail ? require(`redevelopment/outputManage/openedInvoice/${rollDetail.templateName}`) : require('app/outputManage/billManage/openedInvoice/view/rollTypeInvoice.html')
const reimburseDetailPage = reimbursementDetail ? require(`redevelopment/input/reimbursement/${reimbursementDetail.templateName}`) : require('app/input/reimburseManage/reimbursement/view/reimburseDetail.html')

const invoiceEditCtrl = invoiceAdd ? require(`redevelopment/outputManage/invoice/${invoiceAdd.controllerName}`) : require('app/outputManage/fillOpenManage/invoice1/InvoiceEditCtrl')
const openedInvoiceDetailCtrl = openedInvoiceDetail ? require(`redevelopment/outputManage/openedInvoice/${detail.controllerName}`) : require('app/outputManage/billManage/openedInvoice/openedInvoiceDetailCtrl')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.controllerName}`) : require('app/outputManage/fillOpenManage/ovatBill/checkBillDetailCtrl')
const redInfoDetailCtrl = redWordInfoDetail ? require(`redevelopment/outputManage/redWordInfo/${redWordInfoDetail.controllerName}`) : require('app/outputManage/fillOpenManage/redWordInfo/redInfoDetailCtrl')
const cancelInvoiceDetailCtrl = cancelInvoiceDetail ? require(`redevelopment/outputManage/cancelInvoice/${cancelInvoiceDetail.controllerName}`) : require('app/outputManage/billManage/cancelInvoice/cancelInvoiceDetailCtrl')
const managementDetailCtrl = managementDetail ? require(`redevelopment/input/management/${managementDetail.controllerName}`) : require('app/input/inputInvoice/management/managementDetailCtrl')
const vehicleDetailCtrl = vehiceDetail ? require(`redevelopment/outputManage/vehicleInvoice/${vehiceDetail.controllerName}`) : require('app/outputManage/fillOpenManage/vehicleInvoice/add')
const rollTypeInvoiceAddCtrl = rollDetail ? require(`redevelopment/outputManage/openedInvoice/${rollDetail.controllerName}`) : require('app/outputManage/billManage/openedInvoice/rollDetailCtrl')
const reimburseDetailCtrl = reimbursementDetail ? require(`redevelopment/input/reimbursement/${reimbursementDetail.controllerName}`) : require('app/input/reimburseManage/reimbursement/reimburseDetailCtrl')

const list_workspaceCtrl = list ? require(`redevelopment/main/workspace/${list.controllerName}`) : require('./list_workspaceCtrl')
const workspaceItemCtrl = detail ? require(`redevelopment/main/workspace/${detail.controllerName}`) : require('./workspaceItemCtrl')
const workspacePage = list ? require(`redevelopment/main/workspace/${list.templateName}`) : require('./view/workspace.html')
const itemPage = detail ? require(`redevelopment/main/workspace/${detail.templateName}`) : require('./view/workspaceItem.html')

export default angular
    .module('app.workspace', ['ui.bootstrap'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('workspace', {
                abstract: true,
                url: '/workspace',
                template: commonTemplate,
                title: '我的工作台',
                default: 'workspace.list',
            })
            .state('workspace.list', {
                url: '/list?approveCode',
                template: workspacePage,
                controller: 'list_workspaceCtrl',
                title: '我的工作台',
                params: { bussinessKey: null },
            })
            .state('workspace.item', {
                url: '/item/:taskId',
                template: itemPage,
                controller: 'workspaceItemCtrl',
                title: '我的工作台',
            })
            .state('workspace.item.detail', {
                url: '/detail/:waitId',
                template: detailInvoicePage,
                controller: 'invoiceEditCtrl',
                title: '详情',
                params: {
                    detailFlag: true,
                },
            })
            .state('workspace.item.opened', {
                url: '/opened/:invoiceId',
                template: openedInvoiceDetailPage,
                controller: 'openedInvoiceDetailCtrl',
                title: '详情',
            })
            .state('workspace.item.bill', {
                url: '/bill/:billId',
                template: billDetailPage,
                controller: 'checkBillDetailCtrl',
                title: '销售单详情',
            })
            .state('workspace.item.redinfo', {
                url: '/redinfo/:infoId',
                template: redInfoDetailPage,
                controller: 'redInfoDetailCtrl',
                title: '红字信息表详情',
            })
            .state('workspace.blue', {
                url: '/blue/:invoiceId',
                template: cancelInvoiceDetailPage,
                controller: 'cancelInvoiceDetailCtrl',
                title: '详情',
            })
            .state('workspace.item.management', {
                url: '/management/:object',
                template: managementDetailPage,
                controller: 'managementDetailCtrl',
                title: '详情',
            })
            .state('workspace.item.vehicle', {
                url: '/vehicle/:waitId',
                template: vehicleDetailPage,
                controller: 'vehicleDetailCtrl',
                title: '详情',
            })
            .state('workspace.item.roll', {
                url: '/roll/:waitId&:code',
                template: rollDetailPage,
                controller: 'rollTypeInvoiceAddCtrl',
                title: '详情',
            })
            .state('workspace.item.reopenVehicleApprove', {
                url: '/reopenVehicleApprove/:invoiceId',
                template: vehicleDetailPage,
                controller: 'vehicleDetailCtrl',
                title: '详情',
            })
            .state('workspace.item.reiburseInfo', {
                url: '/reiburseInfo/:expenseId',
                template: reimburseDetailPage,
                controller: 'reimburseDetailCtrl',
                title: '详情',
            })
    }])
    .controller('list_workspaceCtrl', list_workspaceCtrl.default)
    .controller('workspaceItemCtrl', workspaceItemCtrl.default)
    .controller('redInfoDetailCtrl', redInfoDetailCtrl.default)
    .controller('checkBillDetailCtrl', checkBillDetailCtrl.default)
    .controller('invoiceEditCtrl', invoiceEditCtrl.default)
    .controller('openedInvoiceDetailCtrl', openedInvoiceDetailCtrl.default)
    .controller('cancelInvoiceDetailCtrl', cancelInvoiceDetailCtrl.default)
    .controller('managementDetailCtrl', managementDetailCtrl.default)
    .controller('vehicleDetailCtrl', vehicleDetailCtrl.default)
    .controller('rollTypeInvoiceAddCtrl', rollTypeInvoiceAddCtrl.default)
    .controller('reimburseDetailCtrl', reimburseDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/main/workspace/index.js